import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { resolveInternalTranslationKey } from 'asset/translation/resolveInternalTranslationKey';

@JsonObject()
export class ReportFilterOption {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true, afterDeserialize: resolveInternalTranslationKey }) readonly name: string
    ) {}
}

@JsonObject()
export class ReportFilters {
    constructor(
        @JsonProperty({ required: true, type: ReportFilterOption }) readonly templates: ReportFilterOption[],
        @JsonProperty({ required: true }) readonly locations: string[],
        @JsonProperty({ required: true, type: ReportFilterOption }) readonly languages: ReportFilterOption[],
        @JsonProperty({ required: true }) readonly originTypes: string[],
        @JsonProperty({ required: true }) readonly ownership: string[]
    ) {}
}
